import { ICardFeesFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/cardFeesFormMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
    meta: ICardFeesFormMeta
} & Partial<TFormUIProps>;

const CardFeesFormUI: React.FC<Props> = ({ isLoading, meta }) => {
    const { register, formState: {errors} } = useFormContext();

    return (
        <CC.Box>
            
            <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={10} my={4}>
                {displayCustomInputs<ICardFeesFormMeta>(
                meta,
                register,
                errors,
                isLoading
                )}
            </CC.SimpleGrid>
        
        </CC.Box>
    );
};

export default CardFeesFormUI;
